// import Stack from '@mui/material/Stack'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {useEffect} from 'react';
import { useGlobalError } from '../../context/Error/GlobalErrorContext';


const GlobalError = () => {
  const { error, clearError } = useGlobalError();

  useEffect(() => {
    if (error.open) {
      const timer = setTimeout(clearError, 3000);
      return () => clearTimeout(timer);
    }
  }, [error.open, clearError]);

  if (!error.open) return null; 

  return (
    <>
      {error.messages.map((msg, index) => (
        <Snackbar
          key={index}
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          style={{ bottom: 24 + index * 70 }}
        >
          <Alert variant="filled" severity={error.tag}>
            {msg}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default GlobalError;





// import Stack from '@mui/material/Stack';
// // import Button from '@mui/material/Button';
// import Snackbar from '@mui/material/Snackbar';
// // import MuiAlert from '@mui/material/Alert';
// import Alert from '@mui/material/Alert';
// import {useEffect, useState} from 'react';

// interface Dialog {
//     err: boolean;
//     errMess: {};
//     tag: 'warning' | 'success' | 'error';
//     errBack: (data: boolean) => void;
// }

// const Error = ({err, errBack, errMess, tag}: Dialog) => {
//     const [errState, setErrState] = useState<boolean>(false)
//     const [mess, setMess] =useState<string[]>([])
//     const [errtag, setErrtag] =useState<'warning' | 'success' | 'error'>('warning')

//     useEffect(() => {
//         setErrState(err)
//         setErrtag(tag)

//         if(typeof errMess === 'object'){
//             const messages = Object.values(errMess as Record<string, string[]>).flat();
//             setMess(messages)
//         }
//         if(typeof errMess === 'string'){
//             setMess([errMess])
//         }
//         // eslint-disable-next-line
//     }, [err])

//     useEffect(() => {
//         if(errState){
//             setTimeout(() => {
//                 setErrState(false)
//                 errBack(false)
//             }, 3000)
//         }
//         // eslint-disable-next-line
//     }, [errState])
    
//     return (
//         <>
//             <Stack sx={{ width: '350px' }} spacing={2}>
//                 {
//                     mess.map((msg, inx)=>(
//                         <Snackbar key={inx} open={errState} style={{bottom: 24 + inx * 70}} autoHideDuration={1000}  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
//                             <Alert variant="filled"  sx={{ width: '350px' }} severity={errtag}>
//                                 {msg}
//                             </Alert>
//                         </Snackbar>
//                     ))
//                 }
//             </Stack>
//         </>
//     )
// }

// export default Error


